/*
Abstractions for API requests
For Authorization
*/

import ApiBase from '@/api/base'
import { API_BASE } from '@/api/const'

const appDataPath = API_BASE + '/auth'

class AuthApiBase extends ApiBase {
  apiName = ''
  get apiBaseUrl () { return `${appDataPath}/${this.apiName}` }
}

/* Student Profile authorization rules */
export class AuthSPInfoApi extends AuthApiBase {
  apiName = 'sp-info'
  get url () {
    return `${this.apiBaseUrl}`
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js